<div mat-dialog-content>
    <p class="mat-headline-5">{{ message }}</p>
</div>
<div mat-dialog-actions fxLayout="row" fxFlexFill>
    <button fxFlex mat-raised-button color="warn" (click)="onNoClick()">{{ "GENERAL.no" | translate }}</button>
    <button fxFlex mat-raised-button color="primary" [mat-dialog-close]="true" cdkFocusInitial>{{ "GENERAL.yes" | translate }}</button>
</div>
